import axios from 'axios';

// URL da API configurável por ambiente (definida no docker-compose / .env do CRA);
// o fallback serve o desenvolvimento local fora do Docker.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8001',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    if (error.response?.status === 403) {
      // Disparar evento customizado para o Modal Global
      const event = new CustomEvent('api-error', { 
        detail: { 
          title: 'Acesso Negado', 
          message: 'Não tens permissões suficientes para realizar esta operação.',
          type: 'danger' 
        } 
      });
      window.dispatchEvent(event);
    }
    return Promise.reject(error);
  }
);

export default api;
